import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {Order} from "../shop/order.model";

export class OrdersDgSearchResults extends GenericDgSearchResults {
  public results: Order[];

  constructor(total: number, results: Order[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
